import * as modules from "./modules/";
import config from "../../../../config";
const { vendor } = config;

const ResetPasswordModal = modules[vendor]
  ? modules[vendor]
  : modules["default"];

export default ResetPasswordModal;
